var index = {
  icon: {
    size: '2rem',
    color: '{overlay.modal.color}'
  },
  content: {
    gap: '1rem'
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
